<form class="popupForm" style="min-height: 300px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      New Subscription Record
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important; min-height: 300px;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        >.< error. <br>{{errMsg}}
      </div>
      <div *ngIf="state==='edit'">
        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
             *ngIf="validationResult && !validationResult.isValid && validationResult.message">
          <mat-icon color="warn">error</mat-icon><span>{{ validationResult.message }}</span>
          <br>
        </div>
        <div>
          Add title text:
        </div>
        <mat-form-field appearance="outline" color="accent" style="width: 100%">
          <mat-label>Title text</mat-label>
          <input matInput id="mkdir-name-input" type="text"
                 (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" (keydown.enter)="handleSubmit($event)"
                 cdkFocusInitial formControlName="textInput">
        </mat-form-field>
        <div>
          Event date:
        </div>
        <mat-form-field appearance="outline" color="accent" style="width: 55%">
          <mat-label>Select day</mat-label>
          <input matInput type="text" [matDatepicker]="dp1"
                 (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" (keydown.enter)="handleSubmit($event)"
                 formControlName="eventDateInput">
          <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
          <mat-datepicker #dp1 disabled="false"></mat-datepicker>
        </mat-form-field>
        &nbsp;
        <mat-form-field appearance="outline" color="accent" style="width: 40%">
          <mat-label>Hours</mat-label>
          <select matNativeControl formControlName="eventHourInput">
            <option value="00:00">00:00</option>
            <option value="07:00">07:00</option>
            <option value="08:00">08:00</option>
            <option value="09:00">09:00</option>
            <option value="10:00">10:00</option>
            <option value="11:00">11:00</option>
            <option value="12:00">12:00</option>
            <option value="13:00">13:00</option>
            <option value="14:00">14:00</option>
            <option value="15:00">15:00</option>
            <option value="16:00">16:00</option>
            <option value="17:00">17:00</option>
            <option value="18:00">18:00</option>
            <option value="19:00">19:00</option>
            <option value="20:00">20:00</option>
            <option value="21:00">21:00</option>
            <option value="22:00">22:00</option>
            <option value="23:00">23:00</option>
            <option value="23:59">23:59</option>
          </select>
        </mat-form-field>
        <div>
          Subscription deadline:
        </div>
        <mat-form-field appearance="outline" color="accent" style="width: 55%">
          <mat-label>Select day</mat-label>
          <input matInput type="text" [matDatepicker]="dp2"
                 (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" (keydown.enter)="handleSubmit($event)"
                 formControlName="eventDeadlineInput">
          <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
          <mat-datepicker #dp2 disabled="false"></mat-datepicker>
        </mat-form-field>
        &nbsp;
        <mat-form-field appearance="outline" color="accent" style="width: 40%">
          <mat-label>Hours</mat-label>
          <select matNativeControl formControlName="deadlineHourInput">
            <option value="00:00">00:00</option>
            <option value="07:00">07:00</option>
            <option value="08:00">08:00</option>
            <option value="09:00">09:00</option>
            <option value="10:00">10:00</option>
            <option value="11:00">11:00</option>
            <option value="12:00">12:00</option>
            <option value="13:00">13:00</option>
            <option value="14:00">14:00</option>
            <option value="15:00">15:00</option>
            <option value="16:00">16:00</option>
            <option value="17:00">17:00</option>
            <option value="18:00">18:00</option>
            <option value="19:00">19:00</option>
            <option value="20:00">20:00</option>
            <option value="21:00">21:00</option>
            <option value="22:00">22:00</option>
            <option value="23:00">23:00</option>
            <option value="23:59">23:59</option>
          </select>
        </mat-form-field>
       </div>
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        Cancel
      </button>
      <button type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
        Save
      </button>
    </div>
  </div>
</form>
